// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"36eae93f","732":"429dcb4e","977":"c198281f"}[chunkId] + ".chunk.js";
};